import {default as AuthServiceClass} from "./Auth/AuthService"
import {default as QuizServiceClass} from "./Quiz/QuizService"
import AuthApi from "../Api/UserAuthApi";
import httpClient from "../../config/httpClient";

export const AuthService = new AuthServiceClass(new AuthApi(httpClient))
export const QuizService = new QuizServiceClass()